<template>
  <a-modal
    v-model="visible"
    :title="title"
    :footer="null"
    :closable="false"
    class="adaptive-modal"
    @cancel="closeModal"
  >
    <div class="d-flex flex-column">
      <div class="d-flex flex-column justify-content-center">
        <p class="font-size-16">If you lose this token, just create a new one.</p>
        <p class="font-size-16">It’s only used to identify the wheel, so nothing critical - just don’t share it publicly.</p>
      </div>
      <a-row class="adaptive-modal__footer">
        <a-col class="text-right" :span="24">
          <a-button @click="closeModal">
            Cancel
          </a-button>
          <a-button
            type="primary"
            class="ml-2"
            @click="generate"
          >
            Create new
          </a-button>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    visible: false,
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.visible = true
        } else {
          this.visible = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async generate() {
      const length = 128
      const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
      const randomValues = new Uint32Array(length)
      crypto.getRandomValues(randomValues)
      const token = Array.from(randomValues, v => charset[v % charset.length]).join('')
      this.$emit('createdToken', token)
      this.closeModal()
    },
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>
